export default "__VITE_ASSET__147bc210__"